import { BOT_NAME } from './Bot';
import {
  MAX_AUTO_RESYNC_ENABLED_BATCHES,
  MAX_SUB_PAGES_FOR_RECURSIVE_URLS,
} from './memory';
import { INFO_MULTIMODAL_ONLY_PRO_PLAN_NOTE } from './alertMessage';

export const CREATE_GROUP_SUCCESS = 'Report group successfully created.';

export const UPDATE_GROUP_SUCCESS = 'Report group successfully updated.';

export const DELETE_GROUP_SUCCESS = 'Report group successfully deleted.';

export const DIALOG_TITLE_FOR_DELETE = 'Confirm delete';

export const DIALOG_CONTENT_FOR_DELETE = 'Are you sure?';

export const DIALOG_CONTENT_FOR_REPORT_DELETE =
  'Are you sure you want to delete the report group?';

export const DIALOG_CONTENT_FOR_MEMORY_DELETE =
  'Are you sure you want to delete the memory?';

export const DIALOG_TITLE_FOR_REPORT_GROUP = 'Create a group';

export const DIALOG_CONTENT_FOR_REPORT_GROUP =
  'To create a new group, please enter the details below.';

export const DIALOG_TITLE_FOR_UPDATE_REPORT_GROUP = 'Edit a group';

export const DIALOG_CONTENT_FOR_UPDATE_REPORT_GROUP =
  'To update a group, please enter the details below.';

export const CREATE_REPORT_GROUP_BUTTON_TEXT = '+ Create Group';

export const DIALOG_TITLE_FOR_REPORT_MESSAGE = 'Create a message';

export const DIALOG_CONTENT_FOR_REPORT_MESSAGE =
  'To create a message, please enter the details below.';

export const CREATE_MESSAGE_SUCCESS = 'Report message successfully created.';

export const UPDATE_MESSAGE_SUCCESS = 'Report message successfully updated.';

export const DELETE_MESSAGE_SUCCESS = 'Report message successfully deleted.';

export const DIALOG_TITLE_FOR_GENERAL_MEMORY = 'Create a memory';

export const DIALOG_CONTENT_FOR_GENERAL_MEMORY =
  'To create a memory, please enter the details below.';

export const DIALOG_TITLE_FOR_UPDATE_GENERAL_MEMORY = 'Edit a memory';

export const DIALOG_TITLE_FOR_UPDATE_SAVED_PROMPT = 'Edit saved prompt';

export const DIALOG_TITLE_FOR_CREATE_SAVED_PROMPT = 'Create saved prompt';

export const DIALOG_CONTENT_FOR_UPDATE_SAVED_PROMPT =
  'To update the saved prompt, please enter the details below.';

export const DIALOG_CONTENT_FOR_CREATE_SAVED_PROMPT =
  'To create the saved prompt, please enter the details below.';

export const DIALOG_CONTENT_FOR_UPDATE_GENERAL_MEMORY =
  'To update a memory, please enter the details below.';

export const DIALOG_TITLE_FOR_UPDATE_MEMORY_TITLE = 'Edit memory title';

export const DIALOG_CONTENT_FOR_UPDATE_MEMORY_TITLE =
  'Update the memory title below.';

export const DIALOG_TITLE_FOR_UPDATE_USE_CASE_INSTRUCTIONS =
  'Edit use case instructions';

export const DIALOG_CONTENT_FOR_UPDATE_USE_CASE_INSTRUCTIONS =
  'Update the use case instructions below.';

export const DIALOG_TITLE_FOR_UPDATE_MEMORY_TAGS = 'edit_tag';

export const DIALOG_CONTENT_FOR_UPDATE_MEMORY_TAGS = 'update_tag_details';

export const DIALOG_TITLE_FOR_UPDATE_SHEET_OPTIONS = 'Edit sheet options';
export const DIALOG_CONTENT_FOR_UPDATE_SHEET_OPTIONS =
  'Update Google Sheet ingestion settings below.';

export const NO_REPORT_GROUPS_PLACEHOLDER = 'No report groups found';

export const NO_REPORT_GROUP_MESSAGES_PLACEHOLDER =
  'No report group messages found';

export const NO_MEMORY_LIST_PLACEHOLDER = 'No memory lists found';

export const UPDATE_MEMORY_SUCCESS = 'Memory successfully updated.';

export const SYNC_MEMORY_STARTED =
  'Memory ingestion has started. Please keep checking the status by refreshing the page.';

export const RETRY_MEMORY_INGESTION_STARTED =
  'Memory ingestion retry has started. Please keep checking the status by refreshing the page.';

export const DELETE_MEMORY_SUCCESS = 'Memory successfully deleted.';

export const ENABLE_AUTO_RESYNC_SUCCESS = 'Auto resync enabled.';
export const DISABLE_AUTO_RESYNC_SUCCESS = 'Auto resync disabled.';
export const DIALOG_TITLE_FOR_ENABLE_AUTO_RESYNC = 'Enable auto resync';
export const DIALOG_CONTENT_FOR_ENABLE_AUTO_RESYNC = `Select how often the memory should be automatically synced. You can enable auto resync on up to ${MAX_AUTO_RESYNC_ENABLED_BATCHES} memories.`;
export const DIALOG_CONTENT_FOR_ENABLE_AUTO_RESYNC_GOOGLE_CHAT_SPACE =
  'Auto resync for a Google Chat space runs daily.';
export const DIALOG_CONTENT_FOR_ENABLE_AUTO_RESYNC_GMAIL_AUTO_TRACKING =
  'Auto resync for Gmail tracking runs daily.';
export const DIALOG_TITLE_FOR_DISABLE_AUTO_RESYNC = 'Disable auto resync';
export const DIALOG_CONTENT_FOR_DISABLE_AUTO_RESYNC =
  'Are you sure you want to disable automatic resync for this memory?';

export const CREATE_GENERAL_MEMORY_BUTTON_TEXT = '+ Create Memory';

export const CREATE_MESSAGE_BUTTON_TEXT = '+ Create message';

export const COPY_MESSAGE_BUTTON_TEXT = 'Copy message';

export const OPEN_MESSAGE_BUTTON_TEXT = 'Open message';

export const DELETED_USER_PLACEHOLDER_TEXT = 'Deleted user';

export const NO_USER_LIST_PLACEHOLDER = 'No users found';

export const UPDATE_USER_ACCESS = `${BOT_NAME} access successfully updated.`;

export const UPDATE_USER_ROLE = 'Role successfully updated.';

export const USER_BAR_CHART_LABEL = 'User interaction count';

export const ORG_BAR_CHART_LABEL = 'Org interaction count';

export const DIALOG_TITLE_UPDATE_ROLE = 'Update Role';

export const DIALOG_MESSAGE_UPDATE_ROLE = 'Are you sure about this action?';

export const DIALOG_TITLE_REMOVE_ACCESS = 'Remove Access';

export const DIALOG_TITLE_GRANT_ACCESS = 'Grant Access';

export const UPDATE_SPACE_ACCESS = `${BOT_NAME} access in space successfully updated.`;

export const UPDATE_SPACE_AUTO_INITIATION_ACCESS = `${BOT_NAME} auto initiation in space successfully updated.`;

export const UPDATE_SPACE_AUTO_MEMORY_INGESTION = `${BOT_NAME} auto memory ingestion in space successfully updated.`;

export const dialogMessageForRemovingBotAccessToUser = (displayName: string) =>
  `${displayName} won't be able to access ${BOT_NAME} after this action!`;

export const dialogMessageForEnablingBotAccessToUser = (displayName: string) =>
  `Granting access will allow ${displayName} to use ${BOT_NAME}!`;

export const dialogMessageForDisablingBotAccessInSpace = (
  displayName: string,
) =>
  `Your team won't be able to access ${BOT_NAME} in ${displayName} after this action!`;

export const dialogMessageForEnablingBotAccessInSpace = (displayName: string) =>
  `Granting access will allow your team in ${displayName} to use ${BOT_NAME}!`;

export const dialogMessageForDisablingAutoInitiateInSpace = (
  displayName: string,
) =>
  `${BOT_NAME} won't be able to auto-initiate a conversation in ${displayName} after this action!`;

export const dialogMessageForDisablingAutoMemoryIngestionInSpace = (
  displayName: string,
) =>
  `${BOT_NAME} won't be able to automatically save memory from a conversation in ${displayName} after this action!`;

export const dialogMessageForEnablingAutoInitiateInSpace = (
  displayName: string,
) =>
  `Granting access will allow ${BOT_NAME} to automatically initiate a conversation in ${displayName}!`;

export const dialogMessageForEnablingAutoMemoryIngestionInSpace = (
  displayName: string,
) =>
  `Granting access will allow ${BOT_NAME} to automatically save memory from a conversation in ${displayName}!`;

export const NO_SPACES_PLACEHOLDER = 'No spaces found';
export const DIALOG_CONTENT_FOR_ORGANIZATION_DELETE =
  'Are you sure you want to delete the organization?';
export const DELETE_ORGANIZATION_SUCCESS = 'Organization successfully deleted.';

export const DIALOG_CONTENT_FOR_ORGANIZATION_DELETE_WITH_NAME_CHECK =
  'Deleting an organization is permanent. Type the organization name to confirm.';
export const ORGANIZATION_NAME_LABEL = 'Organization Name';

export const DEACTIVATE_ORGANIZATION_SUCCESS =
  'Your organization account will be deleted immediately if there is no active billing period. If a billing period is active, account will be deleted at the end of the current billing cycle. You may reactivate the account at any time before the billing period ends.';

export const DIALOG_CONTENT_FOR_USER_DELETE =
  'Are you sure you want to delete the user?';

export const DIALOG_CONTENT_FOR_DELETE_SAVED_PROMPT =
  'Are you sure you want to delete this saved prompt?';

export const DIALOG_CONTENT_FOR_SPACE_DELETE =
  'Are you sure you want to delete the space?';

export const DELETE_SUCCESS = 'Successfully deleted.';

export const ALERT_TO_CLICK_CKECK_BOX = `Please click on check box to submit.`;

export const ADD_HANA_MESSAGE = `Please add ${BOT_NAME} to Google Chat and say @${BOT_NAME} hi to create an interaction.`;

export const DIALOG_TITLE_FOR_CANCEL_PLAN = `Change to Free plan`;

export const DIALOG_CONTENT_FOR_CANCEL_PLAN = `Are you sure you want to cancel existing plan and change to Free plan?`;

export const DIALOG_CONTENT_FOR_CANCEL_PLAN_IF_PAST_DUE = `Are you sure you want to cancel the existing plan and switch to the Free plan? If you proceed, the current billing plan will be canceled, and you will be considered a new subscriber.`;

export const CHANGE_PLAN_SUCCESS = (planName: string) =>
  `Subscription changed to ${planName} plan successfully.`;

export const DIALOG_CONTENT_MAX_LENGTH = 2000;

export const OAUTH_REAUTHORIZATION_TITLE = 'Google permissions required';

export const OAUTH_REAUTHORIZATION_CONTENT =
  'Hana needs the required Google permissions to work. Reauthorize with Google and grant all requested permissions when Google prompts you.';

export const OAUTH_REAUTHORIZATION_CTA = 'Reauthorize with Google';

export const DELETE_ORG_BUTTON_TEXT = 'Delete Org';

export const DELETE_USER_BUTTON_TEXT = 'Delete User';

export const DIALOG_TITLE_FOR_DELETE_ORG = 'Delete a organization';

export const DIALOG_CONTENT_FOR_DELETE_ORG =
  'To delete a organization, please enter the details below.';

export const DIALOG_TITLE_FOR_DELETE_USER = 'Delete a user';

export const DIALOG_CONTENT_FOR_DELETE_USER =
  'To delete a user, please enter the details below.';

export const SCHEDULE_DM_ANNOUNCEMENT_BUTTON_TEXT =
  '+ Schedule dm announcement';

export const DIALOG_TITLE_FOR_SCHEDULE_DM_ANNOUNCEMENT =
  'Schedule a dm announcement';

export const DIALOG_CONTENT_FOR_SCHEDULE_DM_ANNOUNCEMENT =
  'To schedule a dm announcement, please enter the details below.';

export const SCHEDULE_DM_ANNOUNCEMENT_SUCCESS =
  'Dm announcement successfully scheduled.';

export const DIALOG_CONTENT_FOR_DM_ANNOUNCEMENT_DELETE =
  'Are you sure you want to delete the dm announcement?';

export const DELETE_DM_ANNOUNCEMENT_SUCCESS =
  'Dm announcement successfully deleted.';

export const DIALOG_TITLE_FOR_ABORT = 'Confirm abort';

export const DIALOG_CONTENT_FOR_DM_ANNOUNCEMENT_ABORT =
  'Are you sure you want to abort the dm announcement?';

export const ABORT_DM_ANNOUNCEMENT_SUCCESS =
  'Dm announcement successfully stopped.';

export const DIALOG_CONTENT_FOR_MEMORY_ABORT =
  'Are you sure you want to abort the memory ingestion?';

export const ABORT_MEMORY_SUCCESS = 'Memory ingestion successfully aborted.';

export const ADD_GOOGLE_DOC_MEMORY_BUTTON_TEXT = '+ Add Google Doc';

export const DIALOG_TITLE_FOR_GOOGLE_DOC_MEMORY = 'Add Google Doc as Memory';

export const DIALOG_TITLE_FOR_RECURSIVE_URL_MEMORY =
  'Scrape URL and sub pages as memory';

export const DIALOG_CONTENT_FOR_GOOGLE_DOC_MEMORY =
  'To add a memory, please enter the Google doc link below.';

export const DIALOG_TITLE_FOR_OAUTH_CONSENT = 'Grant Google permissions';

export const DIALOG_CONTENT_FOR_OAUTH_CONSENT =
  'Additional Google permissions are required. You will be redirected to grant access.';

export const DIALOG_CONTENT_FOR_RECURSIVE_URL_MEMORY = `To add a URL and its sub pages as memory, enter the link below and choose whether to crawl sub pages. Crawling sub pages is available only on the Pro plan. Hana indexes up to ${MAX_SUB_PAGES_FOR_RECURSIVE_URLS} sub pages per memory.`;

export const CREATE_REDIRECT_PROXY_SUCCESS =
  'Redirect proxy successfully created.';

export const DIALOG_TITLE_FOR_UPDATE_REDIRECT_PROXY = 'Edit a redirect proxy';

export const DIALOG_CONTENT_FOR_UPDATE_REDIRECT_PROXY =
  'To update a redirect proxy, please enter the details below.';

export const UPDATE_REDIRECT_PROXY_SUCCESS =
  'Redirect proxy successfully updated.';

export const DIALOG_CONTENT_FOR_REDIRECT_PROXY_DELETE =
  'Are you sure you want to delete the redirect proxy?';

export const DELETE_REDIRECT_PROXY_SUCCESS =
  'Redirect proxy successfully deleted.';

export const CREATE_SERVER_PROXY_BUTTON_TEXT = '+ Create server proxy';

export const DIALOG_TITLE_FOR_CREATE_SERVER_PROXY = 'Create server proxy';

export const DIALOG_CONTENT_FOR_CREATE_SERVER_PROXY =
  'To create server proxy, please enter the details below.';

export const ADD_CONFLUENCE_MEMORY_BUTTON_TEXT = 'Add confluence memory';

export const DIALOG_TITLE_FOR_CONFLUENCE_MEMORY = 'Add a confluence memory';

export const DIALOG_CONTENT_FOR_CONFLUENCE_MEMORY =
  'To add a memory, please enter the confluence space details below.';

export const DIALOG_CONTENT_FOR_CONFLUENCE_MEMORY_DELETE =
  'Are you sure you want to delete the confluence memory?';

export const ADD_JIRA_MEMORY_BUTTON_TEXT = 'Add Jira memory';

export const ADD_GOOGLE_CHAT_SPACE_MEMORY_BUTTON_TEXT = 'Add Chat Space memory';
export const ADD_YOUTUBE_CAPTIONS_MEMORY_BUTTON_TEXT = 'Add YouTube memory';

export const ADD_AUDIO_MEMORY_BUTTON_TEXT = 'Add Audio memory';
export const ADD_IMAGE_MEMORY_BUTTON_TEXT = 'Add Image memory';

export const DIALOG_TITLE_FOR_JIRA_MEMORY = 'Add a Jira memory';

export const DIALOG_TITLE_FOR_GOOGLE_CHAT_SPACE_MEMORY =
  'Add a Chat Space memory';
export const DIALOG_TITLE_FOR_YOUTUBE_CAPTIONS_MEMORY =
  'Add a YouTube captions memory';

export const DIALOG_TITLE_FOR_AUDIO_MEMORY = 'Add an audio memory';
export const DIALOG_TITLE_FOR_IMAGE_MEMORY = 'Add an image memory';

export const DIALOG_CONTENT_FOR_JIRA_MEMORY =
  'To add a memory, please enter the Jira project details below.';

export const DIALOG_CONTENT_FOR_GOOGLE_CHAT_SPACE_MEMORY = `Select a Google Chat space you can access. Hana does not need to be a member. Track space ingests new messages daily, while Ingest history performs a one-time ingestion from the selected date range. Free plans include up to 5 Google Chat space memory batches, while higher plans increase or remove that limit.`;
export const DIALOG_CONTENT_FOR_YOUTUBE_CAPTIONS_MEMORY =
  'Enter the YouTube link and language code for the captions you want Hana to ingest.';

export const DIALOG_CONTENT_FOR_AUDIO_MEMORY =
  'Drop an audio file below to transcribe and add as memory.';
export const DIALOG_CONTENT_FOR_IMAGE_MEMORY =
  'Drop an image file below to summarize and add as memory.';

export const DIALOG_CONTENT_FOR_JIRA_MEMORY_DELETE =
  'Are you sure you want to delete the Jira memory?';

// Tags module dialog titles and messages
export const DIALOG_TITLE_FOR_CREATE_TAG = 'Create tag';
export const DIALOG_TITLE_FOR_UPDATE_TAG = 'Edit tag';
export const DIALOG_TITLE_FOR_DELETE_TAG = 'Delete tag';
export const DIALOG_CONTENT_FOR_CREATE_TAG =
  'To create a tag, please enter the details below.';
export const DIALOG_CONTENT_FOR_UPDATE_TAG =
  'To update the tag, please enter the details below.';
export const DIALOG_CONTENT_FOR_DELETE_TAG =
  'Are you sure you want to delete this tag?';

export const DIALOG_CONTENT_FOR_DELETE_ORGANIZATION_AUTO_INGESTED_MEMORIES =
  'Are you sure you want to delete all automatically ingested memories related to this organization.';

export const DIALOG_CONTENT_FOR_DELETE_USER_AUTO_INGESTED_MEMORIES =
  'Are you sure you want to delete all automatically ingested memories related to you?';

export const DELETE_ORGANIZATION_AUTO_INGESTED_MEMORIES_SUCCESS =
  'All automatically ingested memories related to this organization will be deleted immediately.';

export const DELETE_USER_AUTO_INGESTED_MEMORIES_SUCCESS =
  'All automatically ingested memories related to your account will be deleted immediately.';

export const INVOCATION_HISTORY_STATE_UPDATE_SUCCESS =
  'Invocation history state successfully updated.';

export const BULK_ADD_USERS_SUCCESS = 'User emails processed.';
export const BULK_UPDATE_USERS_SUCCESS = 'User organizations updated.';

export const DIALOG_TITLE_FOR_PROMOTE_ADMIN = 'Promote user role ADMIN ';

export const DIALOG_CONTENT_FOR_PROMOTE_ADMIN =
  'To promote a user to admin, enter their email.';

export const DIALOG_TITLE_FOR_DISCONNECT_CONNECTOR = 'Confirm Disconnect';

export const DIALOG_CONTENT_FOR_DISCONNECT_CONNECTOR = 'Are you sure?';

export const DIALOG_TITLE_FOR_NAME_CONNECTION = 'Name Connection';
export const DIALOG_CONTENT_FOR_NAME_CONNECTION =
  'Please enter a name for this connection.';

export const FILE_PICKER_DIALOG_TITLE = 'Add Google Doc Memory';
export const FILE_PICKER_DIALOG_CONTENT =
  'Select a Google Doc to sync as memory.';
export const FILE_PICKER_DIALOG_MAX_LENGTH = 500;
export const FILE_PICKER_CONFIRM_TEXT = 'Add Memory';
export const SYNC_FILE_PICK_STARTED = 'Sync started!';
export const FILE_PICK_SUCCESS_MESSAGE = 'Memory successfully updated.';

export const DIALOG_TITLE_FOR_GOOGLE_DRIVE_MEMORY =
  'Confirm Google Drive ingestion';
export const DIALOG_WARNING_FOR_GOOGLE_DRIVE_MEMORY = `Please make sure you are not ingesting sensitive information contained in this Google Drive file. If this file contains sensitive information, create a version with obfuscated data before ingesting it. \n\nFor Google Sheets, All rows ingests the complete selected source and splits large sheets into bounded background jobs without silently dropping later rows. Top rows and Bottom rows intentionally create a partial source and support an optional row limit. \n\nFor operational clarity, you can ingest separate sheet tabs as separate batches by using the sheet title filter.`;

export const DIALOG_TITLE_FOR_GMAIL_MEMORY = 'Confirm Gmail ingestion';

export const DIALOG_TITLE_FOR_PDF_INGESTION = 'Confirm PDF ingestion';
export const DIALOG_TITLE_FOR_DOC_DOCX_INGESTION = 'Confirm DOC/DOCX ingestion';
export const DIALOG_TITLE_FOR_AUDIO_INGESTION = 'Confirm audio ingestion';
export const DIALOG_TITLE_FOR_IMAGE_INGESTION = 'Confirm image ingestion';

export const dialogMessageForPdfIngestion = (fileName: string) =>
  `You are about to ingest ${fileName}. Free and Basic plans will process text only. Pro plans will also process images with an advanced parser.`;

export const DIALOG_TITLE_FOR_MEMORY_WARNING = 'Memory ingestion warning';

export const DIALOG_WARNING_FOR_GENERAL_MEMORY =
  'Please make sure you are not ingesting sensitive information directly in Hana using General Text Memory. You can ingest document links which might contain sensitive information (Hana will only remember the link and not the actual content). But pasting any passwords or tokens directly is not advised.';

export const DIALOG_WARNING_FOR_GOOGLE_DOC_MEMORY =
  'Please make sure you are not ingesting sensitive information contained in this Google Doc. If this Google Doc contains some sensitive information. Add this to Google Drive and ingest its link as a general text memory or create a version of this Google Doc with obfuscated sensitive data.';

export const DIALOG_WARNING_FOR_PDF_MEMORY =
  'Please make sure you are not ingesting sensitive information contained in this PDF. If this PDF contains some sensitive information. Add this to Google Drive and ingest its link as a general text memory or create a version of this PDF with obfuscated sensitive data.';
export const DIALOG_WARNING_FOR_DOC_DOCX_MEMORY =
  'Please make sure you are not ingesting sensitive information contained in this document. If this document contains some sensitive information. Add this to Google Drive and ingest its link as a general text memory or create a version of this document with obfuscated sensitive data.';
export const DIALOG_WARNING_FOR_IMAGE_MEMORY = `Please make sure you are not ingesting sensitive information contained in this image. ${INFO_MULTIMODAL_ONLY_PRO_PLAN_NOTE}`;

export const DIALOG_WARNING_FOR_RECURSIVE_URL_MEMORY = `Please make sure you are not ingesting sensitive information contained in this URL. If this URL contains some sensitive information. Add this to Google Drive and ingest its link as a general text memory or create a version of this URL with obfuscated sensitive data. Hana will crawl at most ${MAX_SUB_PAGES_FOR_RECURSIVE_URLS} sub pages.`;

export const DIALOG_WARNING_FOR_CONFLUENCE_MEMORY =
  'Please make sure you are not ingesting sensitive information contained in this Confluence space. If this space contains some sensitive information. Add this to Google Drive and ingest its link as a general text memory or create a version of this space with obfuscated sensitive data.';

export const DIALOG_WARNING_FOR_JIRA_MEMORY =
  'Please make sure you are not ingesting sensitive information contained in this Jira project. If this project contains some sensitive information. Add this to Google Drive and ingest its link as a general text memory or create a version of this project with obfuscated sensitive data.';

export const DIALOG_WARNING_FOR_GOOGLE_CHAT_SPACE_MEMORY =
  'Please ensure the selected chat space does not contain sensitive information.';

export const DIALOG_WARNING_FOR_YOUTUBE_CAPTIONS_MEMORY =
  'Please ensure the selected video does not contain sensitive information.';

export const DIALOG_WARNING_FOR_AUDIO_MEMORY =
  'Please ensure the selected audio does not contain sensitive information.';

export const DIALOG_WARNING_FOR_GMAIL_MEMORY =
  'Please make sure you are not ingesting sensitive information contained in these emails or attachments.';

export const DIALOG_TITLE_FOR_UPDATE_GMAIL_OPTIONS = 'Edit Gmail filters';
export const DIALOG_CONTENT_FOR_UPDATE_GMAIL_OPTIONS =
  'Update the Gmail query/labels and attachment settings. Changing filters will reset the Gmail history cursor and trigger a fresh (bounded) sync on the next resync.';

export const DIALOG_TITLE_FOR_SELECT_CONNECTOR_ACCOUNT =
  'Select Connector Account';
export const DIALOG_CONTENT_FOR_SELECT_CONNECTOR_ACCOUNT =
  'Choose a connector account to use for ingestion.';
